(() => {
  if (window.__completeYourRitualSectionInitialized) return;
  window.__completeYourRitualSectionInitialized = true;

  const SECTION_SELECTOR = '[data-complete-your-ritual-section]';
  const SLIDER_SELECTOR = '.js-complete-your-ritual.swiper';
  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const instances = new Map();
  let hasWarnedMissingSwiper = false;
  let hasWarnedMissingMarkup = false;

  const warnMissingSwiper = () => {
    if (hasWarnedMissingSwiper) return;
    hasWarnedMissingSwiper = true;
  };

  const warnMissingMarkup = () => {
    if (hasWarnedMissingMarkup) return;
    hasWarnedMissingMarkup = true;
  };

  const syncSliderState = (container) => {
    const state = instances.get(container);
    if (!state) return;

    if (mobileQuery.matches) {
      if (!state.swiper) {
        if (typeof window.Swiper !== 'function') {
          warnMissingSwiper();
          return;
        }

        const wrapper = container.querySelector('.swiper-wrapper');
        const slides = container.querySelectorAll('.swiper-slide');
        const nextEl = container.querySelector('.swiper-button-next');
        const prevEl = container.querySelector('.swiper-button-prev');

        if (!wrapper || slides.length === 0) {
          warnMissingMarkup();
          return;
        }

        state.swiper = new window.Swiper(container, {
          slidesPerView: 1,
          spaceBetween: 8,
          loop: false,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl,
            prevEl,
          },
        });
      }
      return;
    }

    if (state.swiper) {
      state.swiper.destroy(true, true);
      state.swiper = null;
    }
  };

  const mountSection = (sectionRoot) => {
    if (!sectionRoot) return;

    const slider = sectionRoot.querySelector(SLIDER_SELECTOR);
    if (!slider) return;

    if (instances.has(slider)) {
      syncSliderState(slider);
      return;
    }

    instances.set(slider, { swiper: null });
    syncSliderState(slider);
  };

  const unmountSection = (sectionRoot) => {
    if (!sectionRoot) return;

    const slider = sectionRoot.querySelector(SLIDER_SELECTOR);
    if (!slider) return;

    const state = instances.get(slider);
    if (!state) return;

    if (state.swiper) {
      state.swiper.destroy(true, true);
    }

    instances.delete(slider);
  };

  const handleMediaQueryChange = () => {
    instances.forEach((_, slider) => syncSliderState(slider));
  };

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', handleMediaQueryChange);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(handleMediaQueryChange);
  }

  document
    .querySelectorAll(SECTION_SELECTOR)
    .forEach((sectionRoot) => mountSection(sectionRoot));

  document.addEventListener('shopify:section:load', (event) => {
    mountSection(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    unmountSection(event.target);
  });
})();
